// Runtime user/session flags, set from /api/me on app load.
// A mutable object (not `let` exports) so every module sees updates.
export interface Session {
  gender: "z" | "m" | "x";   // x = iné / neurčené → rodovo neutrálne oslovenie
  premium: boolean;
  ai: boolean;
  character: string;       // ai_character key (e.g. "nana" | "dodo")
  characterName: string;   // display name of the chosen AI character
  adminId: number | null;  // user id majiteľky/admina → Avatar jej všade ukáže „admin" efekt
}

export const session: Session = {
  gender: "z", premium: false, ai: false, character: "nana", characterName: "Ňaňa", adminId: null,
};

export function setSession(
  opts: {
    gender?: string | null; premium?: unknown; ai?: unknown;
    character?: string | null; characterName?: string | null; adminId?: unknown;
  } = {},
): void {
  const { gender, premium, ai, character, characterName, adminId } = opts;
  if (gender !== undefined && gender !== null) session.gender = gender === "m" ? "m" : gender === "x" ? "x" : "z";
  if (premium !== undefined) session.premium = !!premium;
  if (ai !== undefined) session.ai = ai === true;
  if (character) session.character = character;
  if (characterName) session.characterName = characterName;
  if (adminId !== undefined) session.adminId = (typeof adminId === "number" && adminId > 0) ? adminId : null;
}

// je daný user (podľa akéhokoľvek id poľa) majiteľka/admin?
export function isAdminUser(user: { id?: number; user_id?: number; friend_id?: number } | null | undefined): boolean {
  if (!user || session.adminId == null) return false;
  const uid = user.id ?? user.user_id ?? user.friend_id;
  return uid != null && uid === session.adminId;
}
